import { SET_FEEDER_SERVICE_DISCLAIMER } from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case SET_FEEDER_SERVICE_DISCLAIMER:
      return { ...action.disclaimer };
    default:
      return state;
  }
};
